import React from 'react';
import './DownloadImg.css';

const DownloadImg = ({ imgdata, filename = 'cohort_result.png' }) => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = imgdata;
    link.download = filename;
    link.click();
  };

  return (
    <button className="download-btn" onClick={handleDownload}>
      Download image
    </button>
  );
};

export default DownloadImg;
